export default __webpack_public_path__ + "static/media/logo.94b0fc8d.png";